import { Box, Hidden, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { Link } from 'components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { menuItems } from '../../menu-items';
import { useStyles } from './header-menu.style';

export const HeaderMenu: React.FC = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Hidden smDown>
            <Box className={classes.menu}>
                {menuItems.map((item, i) => (
                    <Link
                        key={i}
                        className={clsx(
                            item.matchingRoutes.some((route) => window.location.pathname === route) && classes.selected,
                            classes.menuItem,
                        )}
                        to={item.route}
                    >
                        <Typography variant="h5">{t(`header:${item.name}`)}</Typography>
                    </Link>
                ))}
            </Box>
        </Hidden>
    );
};
